import React, { useState } from "react";
import { Divider, Menu, MenuItem } from "@mui/material";
import "./freeFrom.scss";

const AddMoreRowTD = ({
  rowId,
  addRowsInBetween,
  deleteRow,
  showRowHeadersMenu,
  role,
}) => {
  const [rowAnchorEl, setRowAnchorEl] = React.useState(null);
  const [indexOfRowOrColToBeAdd, setIndexOfRowOrColToBeAdd] = useState(null);

  const handleAddBetweenRowClose = () => {
    setRowAnchorEl(null);
    setIndexOfRowOrColToBeAdd(null);
  };

  const handleRowClose = (pos) => {
    indexOfRowOrColToBeAdd && addRowsInBetween(indexOfRowOrColToBeAdd, pos);
    setRowAnchorEl(null);
    setIndexOfRowOrColToBeAdd(null);
  };

  const handleDeleteRow = (pos) => {
    indexOfRowOrColToBeAdd && deleteRow(indexOfRowOrColToBeAdd);
    setRowAnchorEl(null);
    setIndexOfRowOrColToBeAdd(null);
  };

  const handleAddBetweenRowClick = (e, id) => {
    setRowAnchorEl(e.currentTarget);
    setIndexOfRowOrColToBeAdd(id);
  };

  return (
    <>
      <button
        className="add-more-row"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={(e) =>
          role !== "validator" &&
          showRowHeadersMenu &&
          handleAddBetweenRowClick(e, rowId)
        }
      >
        {parseInt(rowId) + 1}
      </button>

      {showRowHeadersMenu && (
        <Menu
          anchorEl={rowAnchorEl}
          keepMounted
          open={Boolean(rowAnchorEl)}
          onClose={handleAddBetweenRowClose}
        >
          <MenuItem
            onClick={(e) => {
              handleRowClose("above");
            }}
          >
            Insert Row Above
          </MenuItem>
          <Divider light />
          <MenuItem
            onClick={(e) => {
              handleRowClose("below");
            }}
          >
            Insert Row Below
          </MenuItem>
          <Divider light />
          <MenuItem
            onClick={(e) => {
              handleDeleteRow();
            }}
          >
            Delete Row
          </MenuItem>
        </Menu>
      )}
    </>
  );
};

AddMoreRowTD.defaultProps = {
  showRowHeadersMenu: true,
};

export default AddMoreRowTD;
